module.exports = __webpack_public_path__ + "img/minicode.9315c25b.jpg";